module.exports = __webpack_public_path__ + "img/eyes_female_asian_average_makeup.df88e4af.png";